/**
 * Logikk på varetype (Items.ItemType, StatusType 32). Visningsnavn hentes ALDRI herfra —
 * bruk <StatusBadge statusType={32} />. Konvensjon: Repo Map 03-Entiteter-og-DTOer.md.
 *   4 = batch m/holdbarhet, 5 = batch lagerstyrt → BatchNo (+ ExpiryDate) i ItemBins
 *   6 = serienummer lagerstyrt                    → SerialNo i ItemBins
 *   1/2 = batch/serie kun som dokumentasjon på ordre (ikke lagerstyrt), 7 = struktur (ikke lagerført)
 */
export const ITEM_TYPE_STATUS_TYPE = 32;

export const isTrackedBatch = (itemType: number | null | undefined): boolean =>
  itemType === 4 || itemType === 5;

export const isTrackedSerial = (itemType: number | null | undefined): boolean =>
  itemType === 6;

export const hasExpiryDate = (itemType: number | null | undefined): boolean =>
  itemType === 4;
